import { effect, inject } from '@angular/core';
import { ProductComponentStore } from 'products-data';
import { ItemComponentBase } from 'products-ui';
import {
  CartItemResultRenderTarget,
  CartItemResultRenderTargetComponents,
} from '../../../layouts/cart-item/cart-item-result-layout/render-targets';

export abstract class WireCutCartItemResultLayoutComponentsProviderComponentBase extends ItemComponentBase {
  protected readonly LayoutTargets = CartItemResultRenderTarget;
  protected readonly LayoutComponents = CartItemResultRenderTargetComponents;
  protected readonly productStore = inject(ProductComponentStore);

  constructor() {
    super();
    effect(() => this.productStore.setSelectedProductId(this.productId()));
  }
}
